import { number } from "prop-types";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";

import FnrDivider from "UI/FnrDivider";

const Divider = ({ marginX, ...rest }) => {
  const { isDark } = useMemberToobarContext();

  return (
    <FnrDivider
      color={isDark ? "textSecondary" : "faintTaupe"}
      marginX={marginX}
      {...rest}
    />
  );
};

Divider.propTypes = { marginX: number };

export { Divider };
